import Vue from 'vue';
export default {
  data() {
    return {
      customReportId: null,
      reportParaMeters: [],
      parameterModal: false,
      hasSearch: false,
      searchTitle: '',
      tableItems: [],
      tableHeaders: [],
      tableHeaderValues: [],
    };
  },
  methods: {
    showParameterModal: function (id) {
      this.getCustomReportParameterFunction(id);
    },
    readyAmarParamter: function (data) {
      this.reportParaMeters = [];
      for (const item of data) {
        this.reportParaMeters.push({
          lable: item.caption ? item.caption : 'تعریف نشده',
          type: item.reportBaseType ? item.reportBaseType.title : null,
          typeId: item.reportBaseType ? Number(item.reportBaseType.id) : null,
          isRequired: item.isRequired,
          id: item.id,
          icon: 'mdi-text mdi-18px',
          value: item.value,
          items: [],
          tempValue: '',
          showDate: false,
        });
        if (item.reportBaseType.id > 4) {
          this.getReportParameterDataFunction(
            item.reportBaseType.id,
            this.reportParaMeters.length - 1,
          );
        }
      }
      if (this.load.val) {
        this.load.val = false;
      }
      this.parameterModal = true;
    },
    makeSelectParameterDataReady: function (data, index) {
      this.reportParaMeters[index].items = data;
    },
    dateTimeChange: function (index) {
      this.reportParaMeters[index].tempValue = Vue.moment(
        this.reportParaMeters[index].value,
      ).format('HH:mm:ss jYYYY-jMM-jDD');
    },
    clearDateTime: function (index) {
      this.reportParaMeters[index].showDate = false;
      this.reportParaMeters[index].value = '';
      this.reportParaMeters[index].tempValue = '';
    },
    showSearchModal: function () {
      this.parameterModal = true;
    },
    search: function () {
      let data = {
        reportId: Number(this.customReportId),
        customReportParameterMaps: [],
      };
      for (const item of this.reportParaMeters) {
        if (
          item.isRequired &&
          (item.value === null || item.value === undefined || item.value === '')
        ) {
          this.snackText = `${item.lable} نمی تواند خالی باشد`;
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
        if (item.value !== null && item.value !== undefined && item.value !== '') {
          let val = null;
          if (item.value === true) {
            val = '1';
          } else if (item.value === false) {
            val = '0';
          } else {
            val = item.value;
          }
          data.customReportParameterMaps.push({
            id: item.id,
            value: val.toString(),
          });
        }
      }
      this.hasSearch = true;
      this.setReportParamsForCustomReportAmarFunction(data);
    },
    makeTableReady: function (data) {
      this.tableHeaders = [];
      this.tableItems = [];
      if (!data) {
        this.snackText = 'اطلاعاتی دریافت نشد.';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      let info = JSON.parse(data);
      let header = [];
      if (info.length > 0) {
        header = Object.keys(info[0]);
        this.tableHeaderValues = header;
        const headersTemp = [];
        for (const item of header) {
          headersTemp.push({ text: item, value: item, align: 'center' });
        }
        this.tableHeaders = headersTemp;
      }

      this.tableItems = Object.freeze(info);

      this.parameterModal = false;
    },
    cancelSearch: function () {
      if (this.hasSearch === false) {
        this.$router.push({ name: 'customReportAmar' });
      } else {
        this.parameterModal = false;
      }
    },
    backToCustomReport: function () {
      this.$router.push({ name: 'customReportAmar' });
    },
  },
};
